import { FloatNumber } from './NumberTypes/FloatNumber';
import type { NumbersRange } from './NumbersRange';
import type { Printable } from './Printable';

export class ReleaseTime implements Printable {
  private value: number;
  private unit: string;
  private constructor(time: number, unit: string) {
    this.unit = unit;
    this.value = time;
  }

  static create(time: number, unit?: string) {
    return new ReleaseTime(time, unit ?? 's');
  }

  satisfies(range: NumbersRange) {
    return range.withinRange(this.value);
  }

  toString() {
    return `${this.roundedValue} ${this.unit}`;
  }

  toSecondsText() {
    const unitAsText = this.value === 1 ? 'second' : 'seconds';

    return `${this.roundedValue} ${unitAsText}`;
  }

  private get roundedValue() {
    return FloatNumber.fromNumber(this.value).round(3);
  }
}
